<template>
    <form @submit.prevent="handleCreateCompany" class="is-clearfix">
        <h1 class="title is-3">Create company</h1>
        <div class="columns">
            <div class="column">
                <o-field label="Company name" :type="fieldType('name')" :message="getError('name')">
                  <template #label>
                    Name <span style="color: red">*</span>
                  </template>
                    <o-input v-model="form.name"/>
                </o-field>

                <o-field label="Address" :type="fieldType('address')" :message="getError('address')">
                    <o-input v-model="form.address"/>
                </o-field>

                <o-field label="City" :type="fieldType('city')" :message="getError('city')">
                    <o-input v-model="form.city"/>
                </o-field>

                <o-field label="State" :type="fieldType('state')" :message="getError('state')">
                    <o-select placeholder="Select a state" v-model="form.state" expanded>
                        <option
                            v-for="state in states"
                            :value="state.id"
                            :key="state.id">
                            {{ state.name }}
                        </option>
                    </o-select>
                </o-field>

                <o-field label="Zip" :type="fieldType('zip')" :message="getError('zip')">
                    <o-input v-model="form.zip"/>
                </o-field>

                <o-field label="Phone" :type="fieldType('phone')" :message="getError('phone')">
                    <o-input v-model="form.phone"/>
                </o-field>

                <o-field label="Fax" :type="fieldType('fax')" :message="getError('fax')">
                    <o-input v-model="form.fax"/>
                </o-field>

                <o-field label="Email"
                    :type="fieldType('email')"
                    :message="getError('email')">
                    <o-input
                            placeholder="company@example.com"
                            v-model="form.email"
                            type="email"
                    />
                </o-field>

                <o-field label="Notes" :type="fieldType('notes')" :message="getError('notes')">
                    <vue-editor class="notes-editor" :editor-toolbar="editorToolbar" v-model="form.notes"/>
                </o-field>
            </div>

            <div class="column">
                <o-field label="Lead Owner">
                    <autocomplete-select type="user" v-model="form.lead_owner" :error="getError('lead_owner')" />
                </o-field>

                <o-field label="IBM Number" :type="fieldType('ibm_number')" :message="getError('ibm_number')">
                    <o-input v-model="form.ibm_number"/>
                </o-field>

                <o-field label="IBM Number expiration date" :type="fieldType('ibm_exp_date')" :message="getError('ibm_exp_date')">
                    <datepicker v-model="form.ibm_exp_date" />
                </o-field>

                <o-field label="Tax ID" :type="fieldType('tax_id')" :message="getError('tax_id')">
                    <o-input v-model="form.tax_id"/>
                </o-field>

                <o-field label="HIC License" :type="fieldType('hic_license')" :message="getError('hic_license')">
                    <o-input v-model="form.hic_license"/>
                </o-field>

                <o-field label="DOB Tracking" :type="fieldType('dob_tracking')" :message="getError('dob_tracking')">
                    <o-input v-model="form.dob_tracking"/>
                </o-field>

                <o-field label="DOB Tracking expiration date" :type="fieldType('dob_tracking_exp_date')" :message="getError('dob_tracking_exp_date')">
                    <datepicker v-model="form.dob_tracking_exp_date" />
                </o-field>

                <o-field label="Special Inspection Agency" :type="fieldType('special_inspection_agency')" :message="getError('special_inspection-agency')">
                    <o-input v-model="form.special_inspection_agency"/>
                </o-field>

                <div class="block">
                    <label class="label">Is this client a task-based location?</label>

                    <o-radio :native-value="true" v-model="form.task_based">Yes</o-radio>
                    <o-radio :native-value="false" v-model="form.task_based">No</o-radio>
                </div>
            </div>
        </div>

        <div class="field is-grouped is-pulled-right">
            <p class="control">
                <router-link :to="{ name: 'companies.index' }" class="button" >Cancel</router-link>
            </p>
            <p class="control">
                <button class="button is-success">Save</button>
            </p>
        </div>
    </form>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Datepicker from './../../components/Datepicker'
    import HandlesForm from './../../mixins/HandlesForm'

    export default {
        mixins: [HandlesForm],

        components: {
            Datepicker
        },

        data() {
            return {
                radio: 'Vane',
                form: {
                    email: '',
                    name: '',
                    address: '',
                    city: '',
                    state: '',
                    zip: '',
                    phone: '',
                    fax: '',
                    lead_owner: '',
                    task_based: false,
                    ibm_number: '',
                    ibm_exp_date: '',
                    tax_id: '',
                    hic_license: '',
                    dob_tracking: '',
                    dob_tracking_exp_date: '',
                    special_inspection_agency: ''
                }
            }
        },

        computed: {
            ...mapGetters(['allUsers', 'editorToolbar', 'states']),
        },

        methods: {
            ...mapActions(['createCompany', 'fetchUsers']),

            handleCreateCompany () {
                let submit = this.wrapSubmit(this.createCompany)

                submit(this.form)
                    .then(res => {
                        this.successMessage('Company has been created')
                        this.$router.push(`/companies/${res.data.data.id}`)
                        return res
                    })
            }
        }
    }
</script>
